import * as React from 'react';
import { ORIGINAL_VOGLIO_FIELDS } from '@bondvet/types/voglio';
import { getClientInfo } from 'analytics/lib/clientInfo';
import { CLIENT_APP_URL } from '../constants';

export default function useClientAppUrl(): string {
    const clientInfo = React.useMemo(() => getClientInfo(), []);

    let clientAppUrl = `${CLIENT_APP_URL}/?login_origin=website${
        clientInfo?.clientId ? `&client_id=${clientInfo.clientId}` : ''
    }`;

    if (
        typeof window !== 'undefined' &&
        (sessionStorage.getItem('sem_account_id') !== null ||
            sessionStorage.getItem('sem_campaign_id') !== null ||
            sessionStorage.getItem('sem_ad_group_id') !== null ||
            sessionStorage.getItem('utm_source') !== null ||
            sessionStorage.getItem('utm_medium') !== null)
    ) {
        const voglioFields: { [key: string]: string } = {
            ...ORIGINAL_VOGLIO_FIELDS.reduce((acc, voglioField) => {
                const item = sessionStorage.getItem(voglioField);
                if (item !== null) {
                    return {
                        ...acc,
                        [voglioField]: item,
                    };
                }
                return acc;
            }, {}),
        };

        if (Object.keys(voglioFields).length !== 0) {
            const params = Object.keys(voglioFields)
                .map((key) => `${key}=${encodeURIComponent(voglioFields[key])}`)
                .join('&');

            clientAppUrl = `${clientAppUrl}&${params}`;
        }
    }

    return clientAppUrl;
}
